import React from 'react';
import { useCreditInfo } from 'hook/data/creditInfo.hook';
import { useWhatsChanged } from 'hook/whatsChanged.hook';
import { useLinkHandler, useEventHandler } from 'hook/event.hook';
import { useSeenModulePixel, useViewModule } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { DEBT_ANALYSIS } from 'types/morph.pagePosition.constants';
import DebtAnalysis from './DebtAnalysis';

const DebtAnalysisController = props => {
  const eventHandler = useEventHandler();
  const { creditInfo } = useCreditInfo();
  const whatsChangedMetadata = useWhatsChanged();
  const onLinkClickCallback = useLinkHandler(eventHandler);
  const additionalData = props.additionalData ?? {};
  const atr = getViewModuleTrackingAttributes(
    DEBT_ANALYSIS,
    props.modulePosition,
  );
  const seenPixel = useSeenModulePixel(atr);
  useViewModule(atr);
  return (
    <DebtAnalysis
      creditInfo={creditInfo}
      debtAnalysisState={whatsChangedMetadata}
      onLinkClickCallback={onLinkClickCallback}
      seenPixel={seenPixel}
      modulePosition={props.modulePosition}
      {...additionalData}
    />
  );
};

export default DebtAnalysisController;
